import { FloorData } from "@/interfaces/floorInterface";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios, { AxiosError } from "axios";

const API_URL = process.env.NEXT_PUBLIC_API_URL;

interface FloorState {
  floor: FloorData[];
  error: string | null;
  loading: boolean;
}

const initialState: FloorState = {
  floor: [],
  error: null,
  loading: false,
};

export const getFloorByPropertyId = createAsyncThunk(
  "floor/getFloorByPropertyId",
  async (
    { propertyId }: { propertyId: string | undefined },
    { rejectWithValue }
  ) => {
    try {
      const response = await axios.get(
        `${API_URL}/floor/floor-by-property/${propertyId}`
      );
      return response.data;
    } catch (error: unknown) {
      if (error instanceof AxiosError) {
        return rejectWithValue(
          error.response?.data?.message || "Failed to fetch property"
        );
      } else {
        // Handle other types of errors, if necessary
        return rejectWithValue("An unknown error occurred");
      }
    }
  }
);

const floorSlice = createSlice({
  name: "floor",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getFloorByPropertyId.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getFloorByPropertyId.fulfilled, (state, action) => {
        state.loading = false;
        state.floor = action.payload;
      })
      .addCase(getFloorByPropertyId.rejected, (state, action) => {
        state.loading = false;
        state.error =
          action.error.message || "An error occurred. Please try again.";
      });
  },
});

export default floorSlice.reducer;
